import React from 'react';
import { connect } from 'react-redux';

class adPage extends React.Component {
    render() {
        return (
            this.props.ad ?
                <div className="row">
                    <div className='col-md-12'>
                        <hr className="blue" />
                        <div dangerouslySetInnerHTML={{__html: this.props.ad}}></div>
                    </div>
                </div>
                : null
        );
    }
}
function mapStateToProps(state, ownProps) {
    return {
        ad: state.ad
    };
}
export default connect(mapStateToProps)(adPage);  